<template>
  <div class="loading-container">
    <!-- <div class="back-wrap">
      <a-button @click="$emit('back')">← 返回首页</a-button>
    </div> -->
    <!-- 外层flex，整体高度占页面80% -->
    <div class="loading-wrap">
      <!-- 左侧文书骨架预览 完全复刻原图长短占位 -->
      <div class="skeleton-box">
        <div class="text">智能文书生成中...</div>
        <div class="text">系统正在解析您的文书需求，右侧 AI文书助手正在进行内容作答，等待文书生成完成后可点击【生成 Word 并打开】</div>
        <div class="skeleton-line line-1"></div>
        <div class="skeleton-line line-2"></div>
        <div class="skeleton-line line-3"></div>
        <div class="skeleton-line line-4"></div>
        <div class="skeleton-block block-1"></div>
        <div class="skeleton-block block-2"></div>
        <div class="skeleton-block block-3"></div>
      </div>

      <!-- 右侧生成步骤面板 -->
      <!-- <div class="step-panel">
        <h4>文书生成中</h4>
        <ul class="step-list">
          <li
            v-for="(step, idx) in stepArr"
            :key="idx"
            :class="{ active: stepIndex >= idx }"
          >
            {{ step }}
          </li>
        </ul>
      </div> -->
    </div>
  </div>
</template>

<script setup>
defineOptions({ name: "DocumentLoadingPanel" });
import { ref, onMounted } from "vue";
const emit = defineEmits(["finish", "back"]);

const stepIndex = ref(0);
// 分步计时
const timerList = [1200, 1500, 1000, 1800, 1000];

onMounted(() => {
  let totalTime = 0;
  timerList.forEach((time, idx) => {
    totalTime += time;
    setTimeout(() => {
      stepIndex.value = idx + 1;
      if (idx === timerList.length - 1) {
        setTimeout(() => emit("finish"), 600);
      }
    }, totalTime);
  });
});
</script>

<style scoped lang="less">
.loading-container {
  width: 100%;
  // height: calc(100vh - 88px);
}
.back-wrap {
  margin-bottom: 16px;
}

/* 整体高度80vh，左右卡片等高 */
.loading-wrap {
  display: flex;
  gap: 24px;
  // height: calc(100vh - 12vh);
  height: 100%;
  // padding:  8px 0;
  box-sizing: border-box;
  border: 1px solid #f0f0f0;
  border-radius: 8px;

  @media (max-width: 992px) {
    flex-direction: column;
    height: auto;
  }
}

/* 左侧文书预览卡片 */
.skeleton-box {
  flex: 1;
  height: 100%;
  padding: 40px;
  background: #ffffff;
  border-radius: 12px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 20px;
  .text{
    font-weight: 400;
    font-size: 18px;
  }
  // 短文本线条
  .skeleton-line {
    background: #f0f3f9;
    border-radius: 8px;
  }
  .line-1 {
    width: 30%;
    height: 32px;
    align-self: center;
  }
  .line-2 {
    width: 100%;
    height: 22px;
  }
  .line-3 {
    width: 90%;
    height: 22px;
  }
  .line-4 {
    width: 65%;
    height: 22px;
  }

  // 大块内容框
  .skeleton-block {
    width: 100%;
    flex: 1;
    background: #f0f3f9;
    border-radius: 8px;
  }
  .block-1 {
    flex: 1.2;
  }
  .block-2 {
    flex: 1.2;
  }
  .block-3 {
    flex: 1.2;
  }
}

/* 右侧步骤面板 */
.step-panel {
  width: 280px;
  flex-shrink: 0;
  height: 100%;
  padding: 24px;
  background: #ffffff;
  border-radius: 12px;

  h4 {
    margin: 0 0 20px 0;
    font-size: 18px;
    color: #12213f;
    font-weight: 600;
  }
  .step-list {
    list-style: none;
    padding: 0;
    margin: 0;
    li {
      padding: 12px 0 12px 22px;
      font-size: 15px;
      color: #64748f;
      position: relative;
      border-bottom: 1px solid #f0f0f0;
      &:last-child {
        border-bottom: none;
      }
      &::before {
        content: "";
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #dcdcdc;
        position: absolute;
        left: 0;
        top: 18px;
      }
      &.active {
        color: #1677ff;
        &::before {
          background: #1677ff;
        }
      }
    }
  }
}
</style>
